<h2>{{name}}</h2>
<hr/>
<p>{{desc}}</p>
<p>Once the radio is selected, it's jbValue will be set to the ngModel. The selection (using the same ngModel)
is unique, and when a radio is selected the rest are automatically unselected.<br/>
  It is possible to have different radio groups using the same ngModel with multiple radios selected. To do so, use the
  jbRadioGroup option, assigning different names for every group.
</p>
<p>
  By default the radios are not required. This means that if no option is selected (model matches no value) the form
  that wraps all the inputs will still be valid. If required, the form will only be valid if the model matches one radio.
  <br>
  For more details about the original bootstrap radio: <a href="https://getbootstrap.com/docs/4.0/components/forms/#checkboxes-and-radios">https://getbootstrap.com/docs/4.0/components/forms/#checkboxes-and-radios</a>
</p>

<!--https://getbootstrap.com/docs/4.0/components/forms/#checkboxes-and-radios-->
<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>






<!--Input Customization-->
<div class="whiteBg">
  <div class="row">
    <div class="col-5 marB15">
      <h5 class="marB0">jbRadio Customization:</h5>
      <div class="d-flex justify-content-between">
        <jb-radio class="padT25"
                  [class.block]="compConf.isClassBlock"
                  [style.background]="compConf.isClassBlock ? 'lightgray' : 'white'"
                  [(ngModel)]="myVariable"
                  [jbValue]="compConf.value"
                  [jbLabel]="compConf.labelText"
                  [jbRadioGroup]="compConf.hasGroup?compConf.groupValue:''"
                  [jbDisabled]="compConf.isDisabled"
                  [jbRequired]="compConf.isRequired"
                  [jbTooltip]="(compConf.hasTooltip ? compConf.tooltipText : null)"
                  [jbTooltipPos]="(compConf.tooltipPos || 'top')"
                  [jbTooltipBody]="compConf.tooltipBody"
        ></jb-radio>
        <div class="d-print-inline-flex">
          <jb-input [(ngModel)]="myVariable" jbLabel="myVariable"></jb-input>
        </div>
      </div>

<!--      <div>myOp={{myOp}}</div>-->

      <div class="padT5">
        <div class="code-box pad15">
          <pre>{{customCompCode}}</pre>
        </div>
      </div>
    </div>

    <div class="col-7">

      <!--Value-->
      <div class="row">
        <div class="col-3"><jb-label jbText="Value"></jb-label></div>
        <div class="col-9"> <jb-input [(ngModel)]="compConf.value" (ngModelChange)="upComp()"></jb-input> </div>
      </div>

      <!--Label-->
      <div class="row">
        <div class="col-3"><jb-label jbText="Label"></jb-label></div>
        <div class="col-9" style="margin-bottom: -5px;"> <jb-input [(ngModel)]="compConf.labelText" (ngModelChange)="upComp()"></jb-input> </div>
      </div>

      <!--Radio Group-->
      <div class="row">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.hasGroup" (ngModelChange)="upComp()" jbLabel="Has Group"></jb-checkbox> </div>
        <div class="col-9" style="margin-bottom: -5px;"> <jb-input [(ngModel)]="compConf.groupValue" (ngModelChange)="upComp()" [jbDisabled]="!compConf.hasGroup"></jb-input> </div>
      </div>

      <!--Required + Disabled-->
      <div class="row marT15">
        <div class="col-3"> <jb-checkbox [(ngModel)]="compConf.isRequired" (ngModelChange)="upComp()" jbLabel="Is Required"></jb-checkbox> </div>
        <div class="col-3"> <jb-checkbox [(ngModel)]="compConf.isDisabled" (ngModelChange)="upComp()" jbLabel="Is Disabled"></jb-checkbox> </div>
      </div>

      <!--Tooltip-->
      <div class="row marT10">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.hasTooltip" (ngModelChange)="upComp()" jbLabel="Has Tooltip"></jb-checkbox> </div>
        <div class="col-9" *ngIf="compConf.hasTooltip">
          <jb-input [(ngModel)]="compConf.tooltipText" (ngModelChange)="upComp()"></jb-input>
        </div>
        <div class="col-5" *ngIf="compConf.hasTooltip">
          <jb-dropdown jbLabel="jbTooltipPos"
                       [(ngModel)]="compConf.tooltipPos" (ngModelChange)="upComp()"
                       [jbList]="[{ id: 'top', text: 'top' }, { id: 'right', text: 'right' }, { id: 'bottom', text: 'bottom' }, { id: 'left', text: 'left' }]"
                       jbRender="text" jbSelect="id">
          </jb-dropdown>
        </div>
        <div class="col-4" *ngIf="compConf.hasTooltip">
          <jb-dropdown jbLabel="jbTooltipBody"
                       [(ngModel)]="compConf.tooltipBody" (ngModelChange)="upComp()"
                       [jbList]="[{ id: 'true', text: 'true' }, { id: 'false', text: 'false' }]"
                       jbRender="text" jbSelect="id">
          </jb-dropdown>
        </div>
      </div>

      <!--Classes-->
      <div class="row padT10">
        <div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.isClassBlock" (ngModelChange)="upComp()" jbLabel="block"></jb-checkbox> </div>
        <!--<div class="col-3 padT5"> <jb-checkbox [(ngModel)]="compConf.hasColon" (ngModelChange)="upComp()" jbLabel="colon"></jb-checkbox> </div>-->
      </div>

    </div>

  </div>
</div>

<hr>






<h5 class="mt-4">Examples:</h5>
<div class="col-12 examples-table">

<!--  <div class="row">-->
<!--    <div class="col-5">-->
<!--      <jb-radio [(ngModel)]="myVariable" jbLabel="Option 1" jbValue="1"></jb-radio>-->
<!--    </div>-->
<!--    <div class="col-7 code-box"> <pre>{{instance}}</pre> </div>-->
<!--  </div>-->

  <div class="row">
    <div class="col-5 ">
      <div class="d-flex justify-content-between">
        <jb-radio [(ngModel)]="myVariable" jbLabel="Option 1" jbValue="1"></jb-radio>
        <jb-radio [(ngModel)]="myVariable" jbLabel="Option 2" jbValue="2"></jb-radio>
        <jb-radio [(ngModel)]="myVariable" jbLabel="Option 3" jbValue="3"></jb-radio>
      </div>
    </div>
    <div class="col-7 code-box"> <pre>{{instance2}}</pre> </div>
  </div>

  <div class="row">
    <div class="col-5">
      <h4 class="d-flex justify-content-between">
        <jb-radio [(ngModel)]="myOp" jbLabel="Option 1" jbValue="100" jbRequired="true"></jb-radio>
        <jb-radio [(ngModel)]="myOp" jbLabel="Option 2" jbValue="200" jbRequired="true"></jb-radio>
        <jb-radio [(ngModel)]="myOp" jbLabel="Option 3" jbValue="300" jbRequired="true"></jb-radio>
      </h4>
    </div>
    <div class="col-7 code-box"> <pre>{{instance3}}</pre> </div>
  </div>

</div>


<!--Applicable classes -->
<div class="row">
  <div class="col-12">
    <hr>
    <h5 class="mt-4">Applicable classes:</h5>
    <p>By default radios are inline elements (displayed one next to another). You can easily turn then to block
      elements by applying class "<b>block</b>":
    </p>
  </div>
  <div class="col-6">
    <pre class="marT10">{{ blockExample }}</pre>
  </div>
  <div class="col-6">
    <jb-radio jbLabel="Inline radio 1"></jb-radio>
    <jb-radio jbLabel="Inline radio 2"></jb-radio>
    <jb-radio jbLabel="Inline radio 3"></jb-radio>
    <hr>
    <jb-radio class="block" jbLabel="Block radio 4"></jb-radio>
    <jb-radio class="block" jbLabel="Block radio 5"></jb-radio>
    <jb-radio class="block" jbLabel="Block radio 6"></jb-radio>
  </div>
</div>


<!--CSS Styling-->
<div class="row marT40">
  <div class="col-12">
    <h3>CSS Styling</h3>
    <p>The following SASS variables can be overridden to provide customized coloring:</p>
    <pre class="padL30">{{ cssReset }}</pre>
  </div>
</div>

